__turbopack_context__.v({
  "wrapper": "html-page-wrapper-module__NI5uBG__wrapper",
});
